import { render, staticRenderFns } from "./RouteMakingEditTrip.vue?vue&type=template&id=10aa5538&scoped=true&"
import script from "./RouteMakingEditTrip.vue?vue&type=script&lang=js&"
export * from "./RouteMakingEditTrip.vue?vue&type=script&lang=js&"
import style0 from "./RouteMakingEditTrip.vue?vue&type=style&index=0&id=10aa5538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa5538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VChip,VIcon,VSkeletonLoader})
